import React, { useState } from 'react';

const newsArticles = [
  {
    id: 1,
    title: 'Angalifu Announces Breakthrough in Electromagnetic Computing',
    excerpt: 'Revolutionary EAPU architecture demonstrates 1000x improvement in distributed computing tasks, marking a paradigm shift in how we approach computational challenges at planetary scale.',
    date: '2024-03-15',
    category: 'Technology',
    author: 'Dr. Sarah Chen',
    readTime: '5 min read',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  },
  {
    id: 2,
    title: 'Partnership with African Union on Digital Infrastructure',
    excerpt: 'Strategic collaboration to deploy EADC technology across 54 member states, establishing Africa as the global leader in next-generation computational infrastructure.',
    date: '2024-03-10',
    category: 'Partnerships',
    author: 'Michael Okonkwo',
    readTime: '3 min read',
    gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
  },
  {
    id: 3,
    title: 'Angalifu Raises $500M in Series C Funding',
    excerpt: 'Investment led by sovereign wealth funds to accelerate global deployment of electromagnetic computing infrastructure and expand research capabilities.',
    date: '2024-03-05',
    category: 'Company',
    author: 'Lisa Thompson',
    readTime: '4 min read',
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
  },
  {
    id: 4,
    title: 'New Research Paper: "Beyond the CAP Theorem"',
    excerpt: 'Peer-reviewed paper demonstrates how EADC transcends traditional distributed computing limits through continuous electromagnetic field computation.',
    date: '2024-02-28',
    category: 'Research',
    author: 'Prof. James Mwangi',
    readTime: '8 min read',
    gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
  },
  {
    id: 5,
    title: 'Angalifu Opens Nairobi Research Center',
    excerpt: 'State-of-the-art facility to house 500 researchers focused on electromagnetic computing, establishing Kenya as the global epicenter of computational innovation.',
    date: '2024-02-20',
    category: 'Company',
    author: 'Amara Diouf',
    readTime: '3 min read',
    gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)'
  },
  {
    id: 6,
    title: 'Climate Modeling Breakthrough Using EADC',
    excerpt: 'Real-time planetary simulation achieves unprecedented accuracy in weather prediction, enabling precise climate intervention strategies.',
    date: '2024-02-15',
    category: 'Technology',
    author: 'Dr. Wei Zhang',
    readTime: '6 min read',
    gradient: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)'
  }
];

const NewsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  const categories = ['All', 'Technology', 'Company', 'Research', 'Partnerships'];

  const filteredArticles = newsArticles.filter(article => {
    const matchesCategory = selectedCategory === 'All' || article.category === selectedCategory;
    const matchesSearch = article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      article.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <>
      <style>{`
        .news-hero {
          padding: 8rem 2rem 4rem;
          background: linear-gradient(to bottom, var(--white), var(--gray-50));
          text-align: center;
        }

        [data-theme="dark"] .news-hero {
          background: linear-gradient(to bottom, var(--gray-900), var(--gray-800));
        }

        .news-title {
          font-size: clamp(2.5rem, 5vw, 4rem);
          font-weight: 800;
          color: var(--black);
          margin-bottom: 1.5rem;
          letter-spacing: -0.03em;
        }

        .news-subtitle {
          font-size: 1.25rem;
          color: var(--gray-600);
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .news-controls {
          padding: 2rem;
          background: var(--white);
          border-bottom: 1px solid var(--gray-200);
          position: sticky;
          top: 80px;
          z-index: 10;
        }

        [data-theme="dark"] .news-controls {
          background: var(--gray-900);
          border-color: var(--gray-700);
        }

        .controls-container {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 2rem;
          flex-wrap: wrap;
        }

        .category-filters {
          display: flex;
          gap: 0.5rem;
          flex-wrap: wrap;
        }

        .category-btn {
          padding: 0.5rem 1rem;
          border: 1px solid var(--gray-300);
          background: var(--white);
          color: var(--gray-700);
          border-radius: var(--radius);
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        [data-theme="dark"] .category-btn {
          background: var(--gray-800);
          border-color: var(--gray-600);
          color: var(--gray-300);
        }

        .category-btn:hover {
          border-color: var(--gray-400);
          transform: translateY(-1px);
        }

        .category-btn.active {
          background: var(--black);
          color: var(--white);
          border-color: var(--black);
        }

        [data-theme="dark"] .category-btn.active {
          background: var(--white);
          color: var(--black);
          border-color: var(--white);
        }

        .search-box {
          position: relative;
          width: 300px;
        }

        .search-input {
          width: 100%;
          padding: 0.75rem 1rem 0.75rem 2.5rem;
          border: 1px solid var(--gray-300);
          border-radius: var(--radius);
          font-size: 0.875rem;
          background: var(--white);
          color: var(--gray-900);
          transition: all 0.2s ease;
        }

        [data-theme="dark"] .search-input {
          background: var(--gray-800);
          border-color: var(--gray-600);
          color: var(--gray-100);
        }

        .search-input:focus {
          outline: none;
          border-color: var(--blue-500);
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .search-icon {
          position: absolute;
          left: 0.75rem;
          top: 50%;
          transform: translateY(-50%);
          width: 20px;
          height: 20px;
          color: var(--gray-400);
        }

        .news-grid {
          max-width: 1200px;
          margin: 0 auto;
          padding: 4rem 2rem;
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 2rem;
        }

        .news-card {
          background: var(--white);
          border-radius: var(--radius-lg);
          overflow: hidden;
          border: 1px solid var(--gray-200);
          transition: all 0.3s ease;
          cursor: pointer;
          display: flex;
          flex-direction: column;
        }

        [data-theme="dark"] .news-card {
          background: var(--gray-800);
          border-color: var(--gray-700);
        }

        .news-card:hover {
          transform: translateY(-4px);
          box-shadow: var(--shadow-xl);
          border-color: var(--gray-300);
        }

        [data-theme="dark"] .news-card:hover {
          border-color: var(--gray-600);
        }

        .news-image {
          height: 200px;
          position: relative;
          overflow: hidden;
        }

        .news-gradient {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .news-logo {
          width: 80px;
          height: 80px;
          opacity: 0.3;
          filter: brightness(0) invert(1);
        }

        .news-category-badge {
          position: absolute;
          top: 1rem;
          left: 1rem;
          padding: 0.375rem 0.75rem;
          background: rgba(0, 0, 0, 0.8);
          color: white;
          border-radius: var(--radius);
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .news-content {
          padding: 2rem;
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .news-meta {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1rem;
          font-size: 0.875rem;
          color: var(--gray-500);
        }

        .news-date {
          display: flex;
          align-items: center;
          gap: 0.25rem;
        }

        .news-card-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: var(--gray-900);
          margin-bottom: 0.75rem;
          line-height: 1.3;
        }

        [data-theme="dark"] .news-card-title {
          color: var(--gray-100);
        }

        .news-excerpt {
          color: var(--gray-600);
          line-height: 1.6;
          margin-bottom: 1.5rem;
          flex: 1;
        }

        [data-theme="dark"] .news-excerpt {
          color: var(--gray-300);
        }

        .news-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 1rem;
          border-top: 1px solid var(--gray-200);
        }

        [data-theme="dark"] .news-footer {
          border-color: var(--gray-700);
        }

        .news-author {
          font-size: 0.875rem;
          color: var(--gray-700);
          font-weight: 500;
        }

        [data-theme="dark"] .news-author {
          color: var(--gray-300);
        }

        .read-time {
          font-size: 0.875rem;
          color: var(--gray-500);
        }

        .no-results {
          text-align: center;
          padding: 4rem 2rem;
          color: var(--gray-500);
        }

        @media (max-width: 768px) {
          .news-hero {
            padding: 6rem 1rem 3rem;
          }
          .controls-container {
            flex-direction: column;
            align-items: stretch;
          }
          .search-box {
            width: 100%;
          }
          .news-grid {
            grid-template-columns: 1fr;
            padding: 2rem 1rem;
          }
        }
      `}</style>

      <section className="news-hero">
        <h1 className="news-title">News & Updates</h1>
        <p className="news-subtitle">
          Stay informed about the latest developments in electromagnetic computing and our journey to transform global computation
        </p>
      </section>

      <div className="news-controls">
        <div className="controls-container">
          <div className="category-filters">
            {categories.map(category => (
              <button
                key={category}
                className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
          <div className="search-box">
            <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input
              type="text"
              className="search-input"
              placeholder="Search articles..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="news-grid">
        {filteredArticles.length > 0 ? (
          filteredArticles.map(article => (
            <article key={article.id} className="news-card">
              <div className="news-image">
                <div className="news-gradient" style={{ background: article.gradient }}>
                  <img src="/logo.png" alt="Angalifu" className="news-logo" />
                  <span className="news-category-badge">{article.category}</span>
                </div>
              </div>
              <div className="news-content">
                <div className="news-meta">
                  <span className="news-date">
                    <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    {new Date(article.date).toLocaleDateString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      year: 'numeric'
                    })}
                  </span>
                  <span className="read-time">{article.readTime}</span>
                </div>
                <h3 className="news-card-title">{article.title}</h3>
                <p className="news-excerpt">{article.excerpt}</p>
                <div className="news-footer">
                  <span className="news-author">{article.author}</span>
                  <span className="read-time">Read more →</span>
                </div>
              </div>
            </article>
          ))
        ) : (
          <div className="no-results">
            <p>No articles found matching your criteria.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default NewsPage;
